import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { LoadingLocalTakeover } from 'web-ui-components/lib/organisms/takeovers';
import { ServicingSection } from 'web-ui-components/lib/global/layout';

import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import withContent from '../../../containers/withContent';
import { parseString } from '../../../helpers/contentParser';
import { checkForMatch } from '../../states/actions';
import copContent, { contentPropTypes } from '../Content/cop.content';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';

export class MakeMatch extends Component {
	constructor(props) {
		super(props);

		this.handleCheckForMatch = this.handleCheckForMatch.bind(this);

		this.state = { checkingForMatch: false };
	}

	handleCheckForMatch() {
		const {
			copCheckTriggered,
			copDetails: { accountNumber, sortCode },
			tryCount,
		} = this.props;

		const checkForMatchDetails = {
			accountNumber,
			copCheckTriggered,
			sortCode,
			tryCount,
		};
		this.setState({ checkingForMatch: true });
		this.props.checkForMatch(checkForMatchDetails);
	}

	render() {
		const { content, handleCancel } = this.props;
		const { title, body, confirmButton, cancelButtonText, loadingHeader } = content;

		return (
			<ServicingSection>
				<LoadingLocalTakeover show={this.state.checkingForMatch} title={loadingHeader}>
					<PageHeading data-test-id="make-match">{title}</PageHeading>
					<StandardBody>{parseString(body)}</StandardBody>
					<NavigationButtonGroup
						primaryButton={
							<NavigationButton.Primary
								data-test-id="lets-make-a-match-check-now-button"
								labelText={confirmButton}
								isLoading={this.state.checkingForMatch}
								loadingText="Checking"
								onClick={this.handleCheckForMatch}
							/>
						}
						tertiaryButtons={
							<NavigationButton.Tertiary
								data-test-id="lets-make-a-match-cancel-button"
								labelText={cancelButtonText}
								onClick={handleCancel}
							/>
						}
					/>
				</LoadingLocalTakeover>
			</ServicingSection>
		);
	}
}

MakeMatch.propTypes = {
	checkForMatch: PropTypes.func,
	content: PropTypes.shape(contentPropTypes),
	copCheckTriggered: PropTypes.func,
	copDetails: PropTypes.shape({
		accountName: PropTypes.string,
		accountNumber: PropTypes.string,
		accountType: PropTypes.string,
		customerId: PropTypes.string,
		customerType: PropTypes.string,
		page: PropTypes.string,
		reference: PropTypes.string,
		sortCode: PropTypes.string,
	}),
	handleCancel: PropTypes.func,
	tryCount: PropTypes.number.isRequired,
};

export default compose(connect(null, { checkForMatch }), withContent({ content: copContent }))(MakeMatch);
